import React from "react";
import "./AuthorsGuideline.css";

export default function AuthorsGuideline() {
  return (
    <section className="ijacna-authorguide-section">
      <div className="ijacna-authorguide-container">
        <h1 className="ijacna-authorguide-title">AUTHORS GUIDELINES</h1>

        <p className="ijacna-authorguide-text">
          International Journal of Computer Networks and Applications (IJACNA)
          is a scholarly open access online international journal, which aims to
          publish peer-reviewed original research papers in the field of
          Computer Networks and its applications. IJACNA aims to bring the new
          application developments among the researchers and academicians and
          lays the foundation of sharing research knowledge among the
          researchers. All the submitted papers are peer-reviewed by experts in
          the relevant field of Computer Networks and accepted papers are
          published online immediately after receiving the final version of the
          manuscript in the upcoming recent issue.
        </p>

        <div className="ijacna-authorguide-section-block">
          <h2 className="ijacna-authorguide-heading">Plagiarism:</h2>
          <p className="ijacna-authorguide-text">
            Plagiarism is an offense. IJACNA will check all the submitted
            manuscripts against plagiarism using Turnitin plagiarism detection
            software. If plagiarism is found the manuscript will be rejected at
            once. If plagiarism issues arise even after publication of the
            manuscript, the corresponding manuscript will be removed.
          </p>
        </div>

        <div className="ijacna-authorguide-section-block">
          <h2 className="ijacna-authorguide-heading">
            Types of Papers Accepted
          </h2>
          <ul className="ijacna-authorguide-list">
            <li>Research Article</li>
            <li>Review Article</li>
          </ul>
        </div>

        <div className="ijacna-authorguide-section-block">
          <h2 className="ijacna-authorguide-heading">Initial Submission</h2>
          <p className="ijacna-authorguide-text">
            Authors can submit their unpublished original articles in any format
            with the extension .doc or .docx at the time of submission.
          </p>
          <p className="ijacna-authorguide-text">
            Maximum number of authors allowed is 6 only. The authors’ details
            such as name, email IDs will not be permitted to modify at the later
            stages of the peer review process.
          </p>
        </div>

        <div className="ijacna-authorguide-section-block">
          <h2 className="ijacna-authorguide-heading">Accepted Version</h2>
          <p className="ijacna-authorguide-text">
            All the accepted manuscripts should be submitted in single column
            format through the online submission portal with the extension .doc
            or .docx.
          </p>
          <p className="ijacna-authorguide-text">
            The production team of IJACNA will format the manuscript according
            to IJACNA template.
          </p>
        </div>

        <div className="ijacna-authorguide-section-block">
          <h2 className="ijacna-authorguide-heading">
            Final Version Guidelines
          </h2>
          <p className="ijacna-authorguide-text">
            The production team of IJACNA will format the manuscript according
            to IJACNA template.
          </p>
          <ul className="ijacna-authorguide-list">
            <li>Title – Times New Roman font with size 20</li>
            <li>
              Authors Affiliation details – Times New Roman font with size 10
            </li>
            <li>
              Abstract & Index Terms – Times New Roman font with size 10 (Bold)
            </li>
            <li>
              Major Headings – Times New Roman font with size 12 (Uppercase
              Letters)
            </li>
            <li>
              Sub Headings – Times New Roman font with size 11 (Lowercase
              Letters)
            </li>
            <li>Content – Times New Roman font with size 10</li>
            <li>References – Times New Roman font with size 8</li>
            <li>Author Biography – Times New Roman font with size 8</li>
          </ul>
        </div>

        <div className="ijacna-authorguide-section-block">
          <h2 className="ijacna-authorguide-heading">Review Process</h2>
          <p className="ijacna-authorguide-text">
            Manuscripts are received from the authors on the basis that all the
            manuscripts are original unpublished materials and they are not
            under consideration in another journal for publication.All the
            manuscripts submitted to IJACNA will be admitted in the double blind
            review process. All the manuscripts will be sent to minimum of two
            and maximum of four reviewers who are expert in the subject field.
            Reviewers will send their recommendation along with the reviews to
            the editorial office. Once all the reviews are in the Editorial
            board will make the decision on the manuscripts. The decision will
            be anyone of the following:
          </p>
          <ul className="ijacna-authorguide-list">
            <li>Accept</li>
            <li>Accept with minor revision</li>
            <li>Accept with major revision</li>
            <li>Revise and Resubmit</li>
            <li>Reject</li>
          </ul>
          <p className="ijacna-authorguide-text">
            Submitted manuscripts will be reviewed within 45 days of time.
            <br />
            Once the manuscript is accepted for publication the authors will be
            informed through E-Mail. Authors should prepare the final version of
            the manuscript based on IJACNA template. Authors must transfer the
            copyright form along with the final version of the manuscript to the
            editorial office through Online Mode. Once a manuscript is rejected
            for publication it will not be reconsidered again for publication.
            Authors are informed not to resubmit the rejected manuscripts.
          </p>
        </div>
      </div>
    </section>
  );
}
